(ns frontend.view.modals.entity-editor.events
  (:require
   [frontend.actions.entity :as entity-actions]
   [common.localization :as loc]
   [common.util :as cu :refer [remove-empty-vals]]
   [clojure.string :as string]))

(defn reset-state!
  [state error-state alert-state entity-type mandatory-fields]
  (reset! state {:start-time 0})
  (reset! error-state nil)
  (reset! alert-state nil)

  (swap! state assoc
    :entity-type entity-type
    :mandatory-fields mandatory-fields))

(defn has-text?
  [txt]
  (->> txt
       (str)
       (string/trim)
       (seq)))

(defn validate-form
  [entity-state view-state]
  ;; todo comments for what this returns (displayable error texts that are shown to user)
  (let [mandatory-fields (:mandatory-fields @view-state)
        ;; todo - merge live updates and draft-entity to have single data source
        errors (:errors @view-state)]
    (->> (flatten [(some->> errors
                            (remove nil?)
                            (map second))
                   (->> mandatory-fields
                        (map (fn [mf]
                               (when-not (has-text? (get @entity-state mf))
                                 mf)))
                        (remove nil?)
                        (map (fn [kv]
                               (loc/tr :mandatory-field/value-not-set [(loc/tr kv)]))))])
         (remove nil?))))

(defn on-submit!
  [state draft-state on-success! on-error!]
  (entity-actions/*->entity-update! (:entity-id @state)
                                    (remove-empty-vals
                                     (merge @draft-state
                                            {:entity/type (:entity-type @state)}
                                            (when (= :entity.type/named-value (:entity-type @state))
                                              {:named-value/attribute (:attribute @state)})
                                     ))
                                    on-success!
                                    on-error!))
